import axios from "axios";
import GtfsRealtimeBindings from "gtfs-realtime-bindings";

import { apiKey, apiPrefix } from "../config";
import { getOccupancyStatusString, getScheduleRelationshipString } from "./helpers";

//* Get OccupancyData
export const getGTFS_RT_vehiclePositions = async (agencyId: string): Promise<VehiclePositionsData[] | null> => {
  const vehiclePositionsData = [] as VehiclePositionsData[];

  try {
    const url: string = `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/gtfs-rt/vehiclePositions`;

    const response = await axios.get(url, { headers: {}, responseType: "arraybuffer" });
    if (response.status !== 200) {
      const error = new Error(`${response.config.url}: ${response.status} ${response.statusText}`);
      console.log("error:", error);
    }

    const buffer: Uint8Array = new Uint8Array(response.data);
    const feed = GtfsRealtimeBindings.transit_realtime.FeedMessage.decode(
      buffer
    ) as GtfsRealtimeBindings.transit_realtime.FeedMessage;
    // console.log("feed?.entity:", feed?.entity);

    feed?.entity.forEach((dataGTFS: GtfsRealtimeBindings.transit_realtime.IFeedEntity) => {
      const objectDataGTFS = {
        vehicleName: dataGTFS?.id as string,
        vehicleId: dataGTFS?.vehicle?.vehicle?.id as string,
        routeId: dataGTFS?.vehicle?.trip?.routeId as string,
        tripId: dataGTFS?.vehicle?.trip?.tripId as string,
        scheduleRelationship: getScheduleRelationshipString(
          dataGTFS?.vehicle?.trip?.scheduleRelationship as number
        ) as string, //* Default "UNKNOWN" - no need to check hasOwnProperty!
        occupancyStatus: (dataGTFS?.vehicle as GtfsRealtimeBindings.transit_realtime.IVehiclePosition)?.hasOwnProperty(
          "occupancyStatus"
        )
          ? (getOccupancyStatusString(dataGTFS?.vehicle?.occupancyStatus as number) as string)
          : null, //* Need to check hasOwnProperty!
      };
      vehiclePositionsData.push(objectDataGTFS);
    });
    // console.log("vehiclePositionsData:", vehiclePositionsData);
    return vehiclePositionsData;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log("error?.response?.status:", error?.response?.status);
    }
    if (error instanceof Error) {
      console.log("error?.message:", error?.message);
      console.log("error?.status:", error?.name);
    }
    return null;
  }
};

//* Add occupancyStatus data
export const addOccupancyStatusData = (busSet: BusInfo[], occupancyData: VehiclePositionsData[]): BusInfo[] => {
  for (let i = 0; i < busSet?.length; i++) {
    for (let j = 0; j < occupancyData?.length; j++) {
      if (busSet[i]?.id === occupancyData[j]?.vehicleId) {
        busSet[i].vehiclePositionsData = occupancyData[j];
      }
    }
  }
  return busSet;
};
